module.exports = __webpack_public_path__ + "static/media/ban4.a02c4f18.png";